module.exports = " <span>{{time}}</span> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/countdown/index.vue
// module id = 216
// module chunks = 2